module.exports = __webpack_public_path__ + "static/step-2-1e88ec94ceba59898dc2471c3d34ac15.png";